import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CheckoutService } from '../services/checkout.service';

@Injectable()
export class ExpressCheckoutInterceptor implements HttpInterceptor {

  private readonly checkoutService = inject(CheckoutService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isExpressCheckout = this.checkoutService.isExpressCheckout();

    if (!isExpressCheckout) {
      return next.handle(req);
    }

    if (this.shouldAddExpressCheckoutHeader(req.url)) {
      const cloned = req.clone({
        setParams: {
          expressCheckout: 'true'
        }
      });

      return next.handle(cloned);
    }

    return next.handle(req);
  }

  private shouldAddExpressCheckoutHeader(url: string): boolean {
    const patterns = [
      /users\/[^/]+\/cart\/[^/]+\/payment\/paypal\/adyen\/do(?:$|[/?#])/,
      /users\/[^/]+\/carts\/[^/]+\/adyen\/express-checkout\/paypal\/update-order(?:$|[/?#])/,
      /users\/[^/]+\/carts\/[^/]+\/addresses\/delivery(?:$|[/?#])/,
      /users\/[^/]+\/carts\/[^/]+\/addresses\/billing(?:$|[/?#])/,
      /users\/[^/]+\/orders(?:$|[/?#])/,
      /orders\/[^/]+\/payment\/adyen\/continue(?:$|[/?#])/
    ];

    return patterns.some((pattern) => pattern.test(url));
  }
}
